import { Box } from '@mui/material'
import { C1EmptyIndicator } from 'components/core/empty-indicator/C1EmptyIndicator'
import { C1MultiUserDisplay } from 'components/core/multi-user/C1MultiUserDisplay'
import { DisplayUserNames } from 'components/core/search/users'
import { C1EntitlementDisplayNameWithFetch } from 'components/pages/entitlement/display-name'
import { stepsFromInstance, currentStepInstance } from 'components/pages/task/details/policy-workflow'
import { NoApproverDisplay } from 'components/pages/task/details/task-content-v2/task-review-details/TaskReviewDetailsComponents'
import { TaskValue } from 'lib/actions/task'
import { TaskProcessingType, TaskState } from 'pbts/c1/api/task/v1/task'
import { FC } from 'react'

type GroupAssignedToProps = {
  row: TaskValue
  appGroupId: string
  appId: string
}

const GroupAssignedTo: FC<GroupAssignedToProps> = ({ row, appGroupId, appId }) => {
    if (appGroupId !== '' && appId !== '') {
        return <C1EntitlementDisplayNameWithFetch
            entitlementId={appGroupId}
            appId={appId}
        />
    }

    if (row.stepApprovers) {
        return <DisplayUserNames expandable proposedOptions={row.stepApprovers} />
    }

    return <NoApproverDisplay isTaskProcessing={row.processing === TaskProcessingType.PROCESSING} />
}

type TaskAssignedToProps = {
  task: TaskValue
}

export const TaskAssignedTo: FC<TaskAssignedToProps> = ({ task }) => {
    const policyInstance = task.policy
    const steps = stepsFromInstance(policyInstance, task)
    const currentStep = currentStepInstance({ steps, policy: policyInstance })
    const approval = currentStep?.step.step.oneofKind === 'approval' ? currentStep?.step.step.approval : undefined

    switch (approval?.typ?.oneofKind) {
        case 'group':
            return <Box component="span">
                <GroupAssignedTo row={task} appGroupId={approval.typ.group.appGroupId} appId={approval.typ.group.appId} />
            </Box>
        case 'webhook':
            // Could also show the system user here
            return null
        default:
            return (
                <Box component="span">
                    {task.stepApprovers
                        ? <C1MultiUserDisplay users={task.stepApprovers} showTooltip showUserStatus />
                        : task.state === TaskState.CLOSED
                            ? <C1EmptyIndicator />
                            : <NoApproverDisplay
                                isTaskProcessing={task.processing === TaskProcessingType.PROCESSING}
                            />
                    }
                </Box>
            )
    }
}
